;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('PayInvoiceController', PayInvoiceController)

  PayInvoiceController.$inject = ['$uibModalInstance', 'balance', 'objType']

  function PayInvoiceController ($uibModalInstance, balance, objType) {
    const self = this
    self.$onInit = () => {
      _.extend(self, {
        cancel: cancel,
        accept: accept,
        refuse: refuse,
        force: force,
        makePayment: makePayment
      })
      init()
    }

    function init () {
      self.objType = objType
      self.objLabel = (self.objType === 'invoice' || self.objType === 'situation') ? 'la facture' : "l'avoir"
      self.thisObj = (self.objType === 'invoice' || self.objType === 'situation') ? 'cette facture' : 'cet avoir'
      self.paid = (self.objType === 'invoice' || self.objType === 'situation') ? 'Payée' : 'Payé'
      self.balance = -balance
      self.currency = 'EUR'
    }
    function accept () {
      $uibModalInstance.close(true)
    }

    function refuse () {
      $uibModalInstance.close(false)
    }

    function force () {
      $uibModalInstance.close('forced')
    }

    function makePayment () {
      $uibModalInstance.close('partly_paid')
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

  }
})(window.angular, window._)
